<template>
  <div id="app">
    <router-view/>
    <div id="logoIntro" class="logo-intro">
      <div id="logoIntroAnimation" class="logo-intro-lockup" aria-hidden="true">
        <img class="logo-intro-mark" src="@/assets/img/logo-1.png" alt="">
        <div class="logo-intro-copy">
          <img class="logo-intro-chinese" src="@/assets/img/logo-2.png" alt="">
          <img class="logo-intro-english" src="@/assets/img/logo-3.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const intro = document.getElementById("logoIntro");
    const animation = document.getElementById("logoIntroAnimation");
    const nav = performance.getEntriesByType("navigation")[0];
    const isReload = nav && nav.type === "reload";
    const hasPlayed = sessionStorage.getItem("logoIntroPlayed") === "1";
    const isNewsDetail = /^\/news\/[^/]+\/?$/.test(window.location.pathname);
    const shouldPlay = !isNewsDetail && (isReload || !hasPlayed);

    if (!intro || !animation) return;

    if (!shouldPlay) {
      intro.remove();
      return;
    }

    sessionStorage.setItem("logoIntroPlayed", "1");

    const hideIntro = () => {
      intro.classList.add("is-hidden");
      setTimeout(() => {
        if (intro && intro.parentNode) intro.remove();
      }, 1000);
    };

    setTimeout(hideIntro, 3000);
  }
}
</script>

<style>
.logo-intro {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #b60005;
  display: grid;
  place-items: center;
}

.logo-intro-lockup {
  width: 400px;
  max-width: 60vw;
  display: grid;
  grid-template-columns: 34% minmax(0, 1fr);
  align-items: center;
  column-gap: clamp(8px, 2vw, 16px);
}

.logo-intro-mark,
.logo-intro-chinese,
.logo-intro-english {
  width: 100%;
  height: auto;
  display: block;
}

.logo-intro-mark {
  opacity: 0;
  transform: scale(0.82);
  animation: logoMarkIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.05s both;
}

.logo-intro-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: clamp(4px, 1vw, 9px);
}

.logo-intro-chinese {
  opacity: 0;
  transform: translateX(24px);
  animation: logoChineseIn 0.65s cubic-bezier(0.22, 1, 0.36, 1) 0.45s both;
}

.logo-intro-english {
  opacity: 0;
  transform: translateY(10px);
  animation: logoEnglishIn 0.55s ease-out 0.9s both;
}

.logo-intro.is-hidden {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.6s ease;
}

@keyframes logoMarkIn {
  0% {
    opacity: 0;
    transform: scale(0.82);
  }
  72% {
    opacity: 1;
    transform: scale(1.04);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes logoChineseIn {
  from {
    opacity: 0;
    transform: translateX(24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes logoEnglishIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
